import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ROICalculatorComponent from '../components/ROICalculator';
import { translations } from '../translations';

const ROICalculator = ({ language = 'en' }) => {
  const t = translations[language];

  const metadata = {
    es: {
      title: "Calculadora ROI Drivi - Calcula el Retorno de Inversión de tu Flota",
      description: "Calcula el retorno de inversión de tu flota con nuestra calculadora ROI. Optimiza costos, reduce gastos y maximiza la eficiencia de tu flota vehicular.",
      keywords: "calculadora roi, retorno de inversión, optimización de flota, ahorro de costos, eficiencia vehicular, gestión de flotas"
    },
    en: {
      title: "Drivi ROI Calculator - Calculate Your Fleet's Return on Investment",
      description: "Calculate your fleet's return on investment with our ROI calculator. Optimize costs, reduce expenses, and maximize your vehicle fleet efficiency.",
      keywords: "roi calculator, return on investment, fleet optimization, cost savings, vehicle efficiency, fleet management"
    }
  };

  const currentMeta = metadata[language];

  return (
    <div>
      <Helmet>
        <title>{currentMeta.title}</title>
        <meta name="description" content={currentMeta.description} />
        <meta name="keywords" content={currentMeta.keywords} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={currentMeta.title} />
        <meta property="og:description" content={currentMeta.description} />
        <meta property="og:url" content={`https://drivi.io/${language}/roi-calculator`} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentMeta.title} />
        <meta name="twitter:description" content={currentMeta.description} />
        
        {/* Canonical URLs */}
        <link rel="canonical" href={`https://drivi.io/${language}/roi-calculator`} />
        <link rel="alternate" hreflang="es" href="https://drivi.io/es/roi-calculator" />
        <link rel="alternate" hreflang="en" href="https://drivi.io/en/roi-calculator" />
      </Helmet>

      {/* Breadcrumb Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-2">
              <Link to={`/${language}`} className="text-gray-500 hover:text-gray-700">
                {language === 'es' ? 'Inicio' : 'Home'}
              </Link>
              <span className="text-gray-400">/</span>
              <span className="text-gray-900">
                {language === 'es' ? 'Calculadora ROI' : 'ROI Calculator'}
              </span>
            </div>
          </div>
        </div>
      </nav>

      {/* ROI Calculator Component */}
      <ROICalculatorComponent language={language} />
    </div>
  );
};

export default ROICalculator; 